import Loader from './loader';

export default class Profile {
    constructor($form) {
        this.$form = $form;
        this.loader = (new Loader(document.querySelector('[data-loader]')));

        this.submit = this.submit.bind(this);
        this.fetch = this.fetch.bind(this);

        this.$form.addEventListener('submit', this.submit);
    }

    async submit(e) {
        e.preventDefault();
        this.loader.loading(true);

        const result = await this.fetch();

        this.loader.loading(false);

        if (result.result === false) {
            this.clearErrors();
            this.setErrors(result.messages);
            return;
        }

        location.href = placeholders.baseUri
            ? placeholders.baseUri + '/' + result.page
            : result.page
        ;
    }

    async fetch() {
        const body = new FormData(this.$form);

        try {
            const request = await fetch(
                placeholders.baseUri ? (placeholders.baseUri + '/ajax/type/66/save') : 'ajax/type/66/save',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                    },
                    body: body
                }
            );
            const result = await request.json();
            return result;
        } catch (e) {
            console.log(e);
        }
    }

    clearErrors() {
        let $errors = this.$form.querySelectorAll('.form__group--error');
        if ($errors.length > 0) {
            $errors.forEach($el => $el.classList.remove('form__group--error'));
            this.$form.querySelectorAll('.form__error').forEach($el => $el.remove());
        }
    }

    setErrors(messages) {
        for (const [key, value] of Object.entries(messages)) {
            let $fieldGroup = this.$form.querySelector('[name="'+ key +'"]').closest('.form__group');
            $fieldGroup.classList.add('form__group--error');

            let div = document.createElement("div");
            div.classList.add('form__error');
            div.innerHTML = value;
            $fieldGroup.append(div);
        }
    }
}